// extracted by mini-css-extract-plugin
export var categoryDetail = "index-module--categoryDetail--c1ftD";
export var leftColumn = "index-module--leftColumn--yMJTB";
export var leftColumnContainer = "index-module--leftColumnContainer--PPRtU";
export var projectContainer = "index-module--projectContainer--K-XXK";
export var projectContainerLine = "index-module--projectContainerLine--fNWdO";
export var rightColumn = "index-module--rightColumn--6kZyN";
export var rightColumnContainer = "index-module--rightColumnContainer--CivDE";